// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueGtag from 'vue-gtag'
import router from './router'
import _ from 'lodash'
import dayjs from 'dayjs'
import empty from 'is-empty'
import VModal from 'vue-js-modal'
import axios from 'axios'
import store from './store/store.js'
import VueCookies from 'vue-cookies'
import { AmplifyPlugin } from 'aws-amplify-vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import awsExports from './aws-exports'
import MarqueeText from 'vue-marquee-text-component'
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/dist/v-dropdown-menu.css' // Base style, required.
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import vueDebounce from 'vue-debounce'
import 'normalize.css'
import '@fortawesome/fontawesome-free/css/all.css'
import * as filters from './js/filters.js'
import {mixinCheckedSeqQuery} from './mixins/index.js'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import localKo from 'dayjs/locale/ko'
import Meta from 'vue-meta'
import Ads from 'vue-google-adsense'
import VueClipboard from 'vue-clipboard2'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
dayjs.locale(localKo)
Amplify.configure(awsExports)
Vue.use(VModal, { dynamic: true })
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$empty = empty
Vue.prototype.$axios = axios
Vue.prototype.$_ = _
Vue.prototype.$kakao = window.Kakao
Vue.use(VueCookies)
Vue.use(vueDebounce)
Vue.use(DropdownMenu)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.component('marquee-text', MarqueeText)
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)
window.Kakao.init(process.env.kakaoJsKey)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.mixin({
  ...mixinCheckedSeqQuery
})
// Or if you want to pass in the lock option
Vue.use(vueDebounce, {
  lock: true
})

// Setting a different event to listen to
Vue.use(vueDebounce, {
  listenTo: 'input'
})

// Listening to multiple events
Vue.use(vueDebounce, {
  listenTo: ['input', 'keyup']
})

// Setting a default timer This is set to '300ms' if not specified
Vue.use(vueDebounce, {
  defaultTime: '700ms'
})
Sentry.init({
  Vue,
  dsn: 'https://3b1a4776304e4543868795a43547ed4a@o1104674.ingest.sentry.io/6131976',
  integrations: [new Integrations.BrowserTracing({
    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    tracingOrigins: ['home.tery.kr', 'testhome.tery.kr', /^\//]
  })],
  tracingOptions: {
    trackComponents: true
  },
  attachProps: true,
  tracesSampleRate: 1.0,
  beforeSend: (event, hint) => {
    let errorMsg = ''
    const hintMsg = hint.originalException || hint.syntheticException
    errorMsg = `[Error]: \n\n`
    // errorMsg += `>>> [STORE_SEQ]: ${VueCookies.get('storeSeq')} \n`
    errorMsg += `>>> [URL]: ${event.request.url} \n`
    errorMsg += `>>> [Message]: ${hintMsg.message} \n ${hintMsg.stack} \n`
    errorMsg += `>>> [UserAgent]: ${event.request.headers['User-Agent']}`
    console.log('Error============================', hintMsg.message, errorMsg)
    if (event.request.url.indexOf('localhost') < 0 && hintMsg.message !== '') {
      if (hintMsg !== undefined && !empty(VueCookies.get('storeSeq'))) {
        axios.get(`${process.env.errUrl}`,
          {
            params: {
              errorMsg: errorMsg
            }
          }).then(response => {
          console.log(response)
        })
      }
    }
  }
})

Vue.use(Meta)

// Google Analytics
const googleAnalyticsKey = store.state.google_analytics_key
Vue.use(VueGtag, {
  config: { id: googleAnalyticsKey },
  appName: 'tery web',
  pageTrackerScreenviewEnabled: true
}, router)

// Google Ads
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense) // 디스플레이 광고
Vue.use(Ads.InArticleAdsense) // 콘텐츠 내 자동 삽입 광고
Vue.use(Ads.InFeedAdsense) // 인피드 광고

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.prototype.$innerWidth = window.innerWidth
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js